/* eslint-disable @typescript-eslint/no-explicit-any */
import Section from 'src/components/sections/Section'
import { useMobile } from 'src/hooks/useMobile'

import type { BannerHighlightItemProps, BannerHighlightProps } from './types'
import { Carousel } from '../common/Carousel'
import { BannerHighlightItem } from './BannerHighlightItem'
import './styles.scss'

function BannerHighlight({
  banners,
  title,
  section,
  locationOnPage,
}: BannerHighlightProps) {
  const { screenWidth } = useMobile()

  function isActiveCarrosel() {
    if (screenWidth < 768 && banners.length > 2) {
      return true
    }

    if (screenWidth >= 768 && screenWidth < 1120 && banners.length > 3) {
      return true
    }

    if (screenWidth >= 1120 && banners.length >= 4) {
      return true
    }

    return false
  }

  const optionsCarousel = {
    slidesPerView: 2,
    breakpoints: {
      320: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1120: {
        slidesPerView: 4,
      },
    },
    autoplay: {
      delay: 60000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  }

  return (
    <Section className="layout__content campaign-main-bannerHighlight">
      {title ? (
        <h1 className="title-BannerHighlight xl:text-[40px] lg:text-[40px] md:text-[40px] text-[30px] font-bold uppercase italic text-center xl:mb-12 lg:mb-12 md:mb-12 mb-[20px] xl:mt-[31px] lg:mt-[31px] mt-[31px]">
          {title}
        </h1>
      ) : (
        <div />
      )}
      {isActiveCarrosel() ? (
        <Carousel options={optionsCarousel}>
          {banners.map((banner: BannerHighlightItemProps, index: number) => (
            <BannerHighlightItem
              key={index}
              banner={banner}
              index={index}
              section={section}
              locationOnPage={locationOnPage}
              title={title}
            />
          ))}
        </Carousel>
      ) : (
        <section className="container_carousel flex justify-center items-center">
          {banners.map((banner: BannerHighlightItemProps, index: number) => (
            <BannerHighlightItem
              key={index}
              banner={banner}
              index={index}
              section={section}
              locationOnPage={locationOnPage}
              title={title}
            />
          ))}
        </section>
      )}
    </Section>
  )
}

export default BannerHighlight
